import FastFactsView from './FastFactsView';

export default FastFactsView;
